export class AuthenticateResponse {
	private postBack: string;
	private cancelPostback: string;

	constructor(postBack: string, cancelPostback: string) {
		this.postBack = postBack;
		this.cancelPostback = cancelPostback;
	}

	getPostBack(): string {
		return this.postBack;
	}

	getCancelPostback(): string {
		return this.cancelPostback;
	}
}
